import styled from "styled-components";

export const StyledDailyBonus = styled.div`
  height: 130px;
  width: 130px;
  margin: 130px auto;
  border-radius: 7px;
  background-color: rgba(38,40,43, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 80px;
  }
  span {
    font-weight: bold;
  }
` as any;
